(function () {
  if (window.__rtFeaturedProductsManualBound) {
    return;
  }
  window.__rtFeaturedProductsManualBound = true;

  function initCarousels() {
    document.querySelectorAll('[id^="rt-featured_products_manual-"] .featured-products').forEach(function (carouselElement) {
      if (!carouselElement || carouselElement.classList.contains('slick-initialized')) {
        return;
      }
      var slickOptions = {
        arrows: true,
        infinite: false,
        slidesToShow: 3.5,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 2, slidesToScroll: 1, arrows: true },
          },
          {
            breakpoint: 600,
            settings: { slidesToShow: 2, slidesToScroll: 1, arrows: true },
          },
        ],
      };

      if (typeof window.jQuery !== 'undefined' && window.jQuery.fn && window.jQuery.fn.slick) {
        window.jQuery(carouselElement).slick(slickOptions);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
  document.addEventListener('shopify:section:load', initCarousels);
})();
